import {
	GameOverview,
	gameOverviewSchema,
} from './schemas/game-overview.schema';

export const getGameOverview = async (
	refreshUrl: string
): Promise<GameOverview | null> => {
	try {
		const response = await fetch(refreshUrl, {
			method: 'GET',
			headers: {
				Accept: 'application/json',
			},
		});

		if (!response.ok) {
			console.warn(`Failed to fetch game overview: ${response.status}`);
			return null;
		}

		const data = await response.json();
		const parsed = gameOverviewSchema.safeParse(data);

		if (!parsed.success) {
			console.warn('Game overview validation warnings', parsed.error);
			return data as GameOverview;
		}

		return parsed.data;
	} catch (error) {
		console.error('Error fetching game overview:', error);
		return null;
	}
};
